import { useLaunchDarklyStatus } from "@assetwatch/auth";
import {
  Alert,
  Container,
  FullPageLoading,
  Stack,
  Title,
} from "@assetwatch/ui";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useFeatureFlags } from "./LaunchDarkly/useFeatureFlags";

export function AppFeatureGate({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const { isReady } = useLaunchDarklyStatus();
  const flags = useFeatureFlags();
  const hasLaunchDarklyClient = Boolean(
    import.meta.env.VITE_LAUNCHDARKLY_CLIENT_ID,
  );

  if (hasLaunchDarklyClient && !isReady) {
    return <FullPageLoading />;
  }

  if (!flags.marketplaceEnabled) {
    return (
      <Container size="sm">
        <Stack gap={16}>
          <Title size="lg">{t("marketplace.featureDisabledTitle")}</Title>
          <Alert
            tone="informative"
            title={t("marketplace.featureDisabledDescription")}
          />
        </Stack>
      </Container>
    );
  }

  return <>{children}</>;
}
